import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { ReactComponent as ResolveLogoSvg } from 'icons/Resolve.svg';
import BossModeIcon from 'icons/BossMode.icon';
import { BUSINESS_ROUTE } from 'data/global';
import { BrandingLogos } from 'types';
import BrandingLogo from 'components/BrandingLogo';

import './Logo.styles.scss';
import './Logo.styles.responsive.scss';

type LogoProps = {
  className?: string;
  brandingLogos?: BrandingLogos;
};

const Logo: React.FC<LogoProps> = (props) => {
  const { className, brandingLogos } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);

  const classes = classNames('logo', className);

  const showBrandingLogo = useMemo(
    () => brandingLogos?.logo || brandingLogos?.mobileLogo,
    [brandingLogos?.logo, brandingLogos?.mobileLogo],
  );

  return (
    <Link to={BUSINESS_ROUTE} aria-label="Resolve logo" className={classes}>
      {isSuperAdmin ? (
        <BossModeIcon className="boss-mode" />
      ) : showBrandingLogo ? (
        <BrandingLogo brandingLogos={brandingLogos} height={40} />
      ) : (
        <ResolveLogoSvg className="resolve-logo" />
      )}
    </Link>
  );
};

export default Logo;
